export default IconInputX => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-input-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M20 13v-4a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h7" />
  <path d="M22 22l-5 -5" />
  <path d="M17 22l5 -5" />
</svg>`;